import { Box, styled, Theme } from '@mui/material';
import { forwardRef, PropsWithChildren } from 'react';

type ColumnWidth = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

const widthMap: Record<ColumnWidth, string> = {
  xxs: '80px',
  xs: '120px',
  sm: '220px',
  md: '400px',
  lg: '500px',
  xl: '600px',
  xxl: '700px',
};

type Props = {
  fixedWidth: ColumnWidth;
  spacing?: keyof Theme['spacingSizes'];
  className?: string;
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  align?: 'flex-start' | 'center' | 'flex-end';
};

const shouldForwardProp = (prop: string) =>
  !['fixedWidth', 'spacing', 'justify', 'align'].includes(prop);

const StyledFixedColumn = styled(Box, {
  shouldForwardProp,
})<Props>(({ theme, fixedWidth, spacing, justify, align }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: widthMap[fixedWidth],
  gap: spacing ? theme.spacing(theme.spacingSizes[spacing]) : 0,
  justifyContent: justify,
  alignItems: align,
}));

const FixedColumn = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, fixedWidth, spacing, className, ...props }, ref) => {
    return (
      <StyledFixedColumn
        ref={ref}
        className={className}
        fixedWidth={fixedWidth}
        spacing={spacing}
        {...props}
      >
        {children}
      </StyledFixedColumn>
    );
  },
);

export default FixedColumn;
